import styled, { keyframes } from 'styled-components';

interface IStyle {
  [key: string]: string;
}

export interface ILoaderProps {
  style?: IStyle;
  className?: string;
}

export const Loader = ({ className, style }: ILoaderProps) => (
  <Loader.Wrapper className={className} style={style} data-qa="loader">
    <Loader.Bar />
  </Loader.Wrapper>
);

const loadIn = keyframes`
  0% { right: 100%; }
  50% { right: 0%; }
  100% { right: 0%; }
`;

const loadOut = keyframes`
  50% { left: 0%; }
  100% { left: 100%; }
`;

Loader.Wrapper = styled.div`
  width: 100%;
  height: 1px;
  position: relative;
  background-color: #b6b6b6;
`;

Loader.Bar = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  animation: ${loadIn} 3s infinite, ${loadOut} 3s infinite;
  background-color: ${({ theme }) => theme.navigation.textColor};
`;
